/**
 * Webfont stylesheet for the console type ramp (Fraunces, IBM Plex Sans,
 * JetBrains Mono). Surfaces that permit third-party requests link this;
 * surfaces that don't (web-chat) simply omit it and fall back to the
 * system stacks named in the font tokens.
 */
export const CONSOLE_FONTS_URL: string =
  "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght,SOFT@0,9..144,300..900,30..100;1,9..144,300..900,30..100&family=IBM+Plex+Mono:ital,wght@0,400;0,500;1,400&family=IBM+Plex+Sans:ital,wght@0,300;0,400;0,500;0,600;1,400&family=JetBrains+Mono:wght@400;500;600&display=swap";
